import * as Yup from "yup";

export const companySettingsValidation = Yup.object().shape({
  companyName: Yup.string().required("Company Name is required"),
  companyUEN: Yup.string().required("Company UEN is required"),
  address1: Yup.string().required("Address 1 is required"),
  address2: Yup.string().required("Address 2 is required"),
  address3: Yup.string(), //.required("Address 3 is required"),
  companyRegNo: Yup.string().required("Company Reg No is required"),
  taxRegNo: Yup.string(), //.required(""),
  country: Yup.string().required("Country is required"),
  companyStartYear: Yup.string().required("Company Start Year is required"),
  zipCode: Yup.string()
    .matches(/^\d{6}$/, "Postal Code should be 6 digits")
    .required("Postal Code is required"),

  email: Yup.string()
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, "Invalid email address")
    .required("Email is required"),
  phoneNo: Yup.string()
    .required("Please enter phone number")
    .matches(/^[0-9]{8}$/, "Phone number must be exactly 8 digits"),

  companySettings: Yup.array().of(
    Yup.object().shape({
      uniqueIDPrefix: Yup.string().required("Unique ID Prefix is required"),
      nextUniqueId: Yup.string()
        .matches(/^[1-9]\d*$/, "Numbers only, first digit cannot be 0")
        .required("Next Unique ID is required"),
      csn: Yup.string().required("CSN is required"),
      haveCpfeSubmission: Yup.bool().required(
        "Have Cpf eSubmission is required",
      ),
      irastaxRefNo: Yup.string().required("iras tax Ref No is required"),
      payDayOfMonth: Yup.string().required("Pay Day Of Month is required"),
      alternatePayDayOfMonth: Yup.string(),
      // .required(
      //   "alternatePayDayOfMonth is required",
      // ),
      noOfWorkingDaysPerWeek: Yup.number().required(
        "No Of Working Days Per Week is required",
      ),
      defaultBankCode: Yup.string().required("default Bank Code is required"),
      haveOnlinePayslip: Yup.bool().required("have Online Payslip is required"),
      haveMobileBreak: Yup.bool().required("have mobile break is required"),
      adjustWTROT: Yup.bool().required("Adjust WTROT is required"),
      adjustOT: Yup.bool().required("Adjust OT is required"),
      adjustWaitingTime: Yup.bool().required("Adjust Waiting Time is required"),
      daysBeforePublicHoliday: Yup.number().required(
        "Days Before Public Holiday is required",
      ),
      locationRadius: Yup.number().default(0).nullable(), //required("Location Radius is required"),

      cpfsalaryLimit: Yup.number().required("cpf salary Limit is required"),
      cpfminSalaryLimit: Yup.number().required(
        "cpf min Salary Limit is required",
      ),
      companyOpenTime: Yup.string().required("company Open Time is required"),
      companyCloseTime: Yup.string().required("company Close Time is required"),
      sdlpercentage: Yup.number().min(0),
      sdlminAmount: Yup.number().min(0),
      sdlmaxAmount: Yup.number().min(0),
      otDayPay_NoOfTime: Yup.number()
        .typeError("Ot DayPay No Of Time")
        .required("Ot DayPay No Of Time is required"),
      otHourly_NoOfTime: Yup.number()
        .typeError("Ot Hourly No Of Time")
        .required("Ot Hourly No Of Time is required"),
      workingHoursPerWeek: Yup.number()
        .typeError("Working Hours Per Week")
        .required("Working Hours Per Week is required"),
      companyLatitude: Yup.number()
        .typeError("Company Latitude is required")
        .required("Company Latitude is required"),
      companyLongitude: Yup.number()
        .typeError("Company Longitude")
        .required("Company Longitude is required"),

      foodAllowanceRate: Yup.number()
        .min(0, "If not applicable enter 0")
        .typeError("Food Allowance Rate is required")
        .required("Food Allowance Rate is required"),
      otFoodAllowanceRate: Yup.number()
        .min(0, "If not applicable enter 0")
        .typeError("Food Allowance Rate")
        .required("Food Allowance Rate is required"),
      // breakTime: Yup.number()
      //   .typeError("Enter valid data")
      //   .required("Break Time is required"),
      // oT1PayRate: Yup.number()
      //   .typeError("Enter valid data")
      //   .required("OT1 Pay Rate is required"),
      // oT2PayRate: Yup.number()
      //   .typeError("Enter valid data")
      //   .required("OT2 Pay Rate is required"),
      // extraHoursRate: Yup.number()
      //   .typeError("Enter valid data")
      //   .required("Extra Hours Rate is required"),
      midNightStartTime: Yup.string().required(
        "Mid Night Start Time is required",
      ),
      midNightEndTime: Yup.string().required("Mid Night End Time is required"),
      loginGraceTime: Yup.string().required("Login Grace Time is required"),
      loginHistoryAccess: Yup.bool().required(
        "login history access is required",
      ),
      isMultipleLogin: Yup.bool().required("is multiple login is required"),
      isMomEnabled: Yup.bool().required("is mom enabled is required"),
      oTontimesheet: Yup.bool().required("ot on timesheet is required"),
    }),
  ),
  emailConfigurations: Yup.array().of(
    Yup.object().shape({
      emailConfigID: Yup.number().required("Email Config ID is required"),
      companyCode: Yup.number()
        .typeError("Company Code")
        .required("Company Code is required"),
      smtpServer: Yup.string().required("SMTP Server is required"),
      smtpPort: Yup.number()
        .typeError("SMTP Port is required")
        .required("SMTP Port is required"),
      senderEmail: Yup.string()
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, "Invalid email address")
        .required("Sender Email is required"),
      senderPassword: Yup.string().required("Sender Password is required"),
      useSSL: Yup.boolean().required("Use SSL is required"),
      useTLS: Yup.boolean().required("Use TLS is required"),
      isEnabled: Yup.boolean().required("Is Enabled is required"),
    }),
  ),
});

export const alertConfigValidation = Yup.object().shape({
  alertConfigId: Yup.number().required("Alert Config Id is required"),
  companyCode: Yup.number().required("Company Code is required"),
  alertFrequency: Yup.string().required("Alert Frequency is required"),
  noofDays: Yup.number()
    .typeError("No Of Days is must be a number")
    .required("No Of Days is required"),
  alertChannel: Yup.string().required("Alert Channel is required"),
  lastSentDate: Yup.string(), // Optional, can add .required() if needed
  createUser: Yup.string().required("Create User is required"),
  createDate: Yup.string().required("Create Date is required"),
  modifyUser: Yup.string().required("Modify User is required"),
  modifyDate: Yup.string().required("Modify Date is required"),
  isActive: Yup.boolean().required("Is Active is required"),
  emailAlertRecipients: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.number().required("Recipient Id is required"),
        alertConfigId: Yup.number().required("Alert Config Id is required"),
        emailAddress: Yup.string()
          .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, "Invalid email address")
          // .email("Invalid email address")
          .required("Email Address is required"),
        isActive: Yup.boolean().required("Is Active is required"),
        companyCode: Yup.number().required("Company Code is required"),
        modules: Yup.array().required("Select at least one module"),
      }),
    )
    .min(1, "At least one recipient is required"),
});

export const announcementValidation = Yup.object().shape({
  companyCode: Yup.number().required("Company Code is required"),
  title: Yup.string().required("Title is required"),
  message: Yup.string().required("Message is required"),
  type: Yup.string().required("Announcement Type is required"),
  code: Yup.array()
    .typeError("Select at least one Announcement To Value")
    .required("Announcement To is required"),
  startDate: Yup.string().required("Announcement Start Date is required"),
  endDate: Yup.string().required("Announcement End Date is required"),
  createUser: Yup.string().required("Create User is required"),
  createDate: Yup.string().required("Create Date is required"),
  modifyUser: Yup.string().required("Modify User is required"),
  modifyDate: Yup.string().required("Modify Date is required"),
  isActive: Yup.boolean().required("Is Active is required"),
});
